<!-- 权限详情 -->
<template>
  <div>
    <div class="model-box">
      <div class="model-title clearfix">
        <span>充值信息</span>
        <a @click="billFun(userInfo.id)" class="select-box-btn bill-btn">查看账单</a>
      </div>
      <div class="model-content">
        <table class="public-table jbxx-table">
          <tr>
            <td class="td-head">公司名称</td>
            <td>{{userInfo.companyName}}</td>
            <td class="td-head">公司简介</td>
            <td>{{userInfo.brief}}</td>
          </tr>
          <tr>
            <td class="td-head">签约类型</td>
            <td>{{$common.toStr(userInfo.signType,dictionary.recharge_type)}}</td>
            <td class="td-head">签约期限</td>
            <td>{{$common.toStr(userInfo.termOfUse,dictionary.term_type)}}</td>
          </tr>
          <tr>
            <td class="td-head">结算方式</td>
            <td>{{$common.toStr(userInfo.settleType,dictionary.settle_type)}}</td>
            <td class="td-head"></td>
            <td></td>
          </tr>
          <tr>
            <td class="td-head">开始日期</td>
            <td>{{userInfo.startTime}}</td>
            <td class="td-head">结束日期</td>
            <td>{{userInfo.endTime}}</td>
          </tr>
        </table>
      </div>
    </div>
    <div class="model-box" v-if="ApiList.length>0">
      <div class="model-title">
        <span>接口单价设置</span>
      </div>
      <div class="model-content">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane v-for="(item,index) in ApiList" :key="index" :label="item.interDesc" :name="item.interId">
            <el-table
              v-if="activeName==item.interId"
              ref="multipleTable"
              :data="item.items"
              border
              header-row-class-name="tableHead"
              style="width: 65.2%">
              <el-table-column
                prop="interDesc"
                label="接口名称"
                min-width="56%">
              </el-table-column>
              <el-table-column
                label="接口单价（元）"
                prop="interUnitPrice"
                min-width="22%">
              </el-table-column>
              <el-table-column
                label="计费方式"
                min-width="22%">
                <template slot-scope="scope">
                  <el-radio v-model="scope.row.feeType" :label="1" disabled>查得</el-radio>
                  <el-radio v-model="scope.row.feeType" :label="2" disabled>查询</el-radio>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <!-- <a class="select-box-btn">确定</a> -->
  </div>
</template>

<script>
export default {
  name: 'PermissionDetailAfterpay',
  data () {
    return {
      type:this.$route.query.type,
      userInfo:{
        id:this.$route.query.id || '',
        companyName:'北京道口金科科技有限公司',
        brief:'道口金科',
        signType:'',
        rechargeAmount:0,
        residualAmount:30,
        termOfUse:'',
        startTime:'',
        endTime:'',
        settleType:''
      },
      dictionary:JSON.parse(localStorage.getItem('dictionary')),
      activeName: '',
      ApiList:[],
    }
  },
  mounted () {
    var _this=this;
    _this.getDetialFun();
  },
  methods:{
    handleClick(tab, event) {
      var _this=this;
      // console.log(tab, event);
    },
    // 获取所有接口列表
    getDetialFun:function(userId){
      var _this=this;
      _this.$axios.get('/requestApi/after/pay/sign/show?id='+_this.userInfo.id)     
        .then(function(response){
          let data = response.data;
          if(data.meta.retCode==0){
            _this.userInfo.companyName=data.data.comName;
            _this.userInfo.shortName=data.data.comBriefName;
            _this.userInfo.residualAmount=data.data.accountAmount;
            _this.userInfo.rechargeAmount=data.data.rechargeAmount;
            _this.userInfo.signType=data.data.signType;
            _this.userInfo.termOfUse=data.data.signTerm;
            _this.userInfo.startTime=data.data.startDate;
            _this.userInfo.endTime=data.data.endDate;
             _this.userInfo.settleType=data.data.settleType;
            _this.ApiList=[];
            data.data.interList.forEach(function(item){
              var itemObj=new Object();
              itemObj.interId=item.interId;
              itemObj.interDesc=item.interDesc;
              itemObj.items=[];
              item.items.forEach(function(itemChild){
                itemObj.items.push(itemChild)
              });
              _this.ApiList.push(itemObj);
            });
            _this.ApiList.forEach(function(item){
              item.items.forEach(function(itemChild){
                if(itemChild.interUnitPrice==null){
                  itemChild.interUnitPrice=0;
                };
              });
            });
            _this.handleClick();
            _this.activeName=_this.ApiList[0].interId;
          }else{
            console.log(data.meta.friendlyMsg);
          }
        })
        .catch(function(error){
          console.log(error)
        });
    },
    //查看账单
    billFun:function(userId){
      this.$router.push({ path: '/AfterpayBillPage', query: {id: userId} });
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.jbxx-table tr td{width: 35%;}
.jbxx-table tr .td-head{width: 15%;}
.select-box-btn{margin: 0 auto;}
.model-title{line-height: 40px;}
.bill-btn{display: inline-block;float: right;}
</style>



// WEBPACK FOOTER //
// src/components/PermissionDetailAfterpay.vue